exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.banner[data-v-1d64ca26] {\n    height: 100px;\n}\nimg[data-v-1d64ca26] {\n    width: 100%;\n    overflow: hidden;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib??vue-loader-options!./resources/assets/js/components/HeaderBanner.vue?vue&type=style&index=0&id=1d64ca26&scoped=true&lang=css&
// module id = zDS0
// module chunks = 58